import React from 'react';
import { motion } from 'framer-motion';

const Login = () => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleGoogleLogin = () => {
    window.location.href = `${BACKEND_URL}/api/auth/google/login`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-4">
      {/* Background subtle grid */}
      <div
        className="fixed inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-sm relative z-10"
      >
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/logo-white.png"
            alt="WorkitDoit"
            className="w-52 mx-auto"
          />
        </div>

        {/* Card */}
        <div className="bg-[#161616] border border-white/10 rounded-xl p-8 shadow-2xl">
          <div className="text-center mb-7">
            <h2 className="text-base font-semibold text-white/90 font-heading">
              CRM & Automatisation
            </h2>
            <p className="text-sm text-white/40 mt-1">
              Connectez-vous pour accéder à votre espace
            </p>
          </div>

          <button
            onClick={handleGoogleLogin}
            data-testid="google-login-button"
            className="w-full flex items-center justify-center gap-3 px-5 py-3.5 rounded-lg border border-white/15 bg-white/5 hover:bg-white/10 hover:border-white/25 text-white text-sm font-medium transition-all duration-200 active:scale-[0.98]"
          >
            <svg className="h-5 w-5 flex-shrink-0" viewBox="0 0 24 24">
              <path fill="#EA4335" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#4285F4" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Se connecter avec Google
          </button>

          <p className="text-[11px] text-white/25 text-center mt-5">
            En vous connectant, vous acceptez nos conditions d'utilisation
          </p>
        </div>

        <p className="text-center text-[11px] text-white/25 mt-6">
          WorkitDoit © 2026 · Tous droits réservés
        </p>
      </motion.div>
    </div>
  );
};

export default Login;
